import { ContactDTO } from '../../queries';

export const onEmployerClickCallback = (contact: ContactDTO) => {
	window.open(`${window.location.origin}/Employer/` + contact?.brokerId);
};
